export default function formatError(err) {
  if (!err.graphQLErrors || !err.graphQLErrors.length) {
    return err.message;
  }
  return err.graphQLErrors.reduce((message, err) => {
    return `${message}\n${err.message}`;
  }, '');
}



// WEBPACK FOOTER //
// ./src/helpers/formatError.js